import { CassettePage } from "./CassettePage";

const Cassette = () => {
	return <CassettePage />;
};
export default Cassette;
